import { writable, derived } from 'svelte/store';
import { v4 as uuid } from 'uuid';
const PREFIX = 's8:session:';
const DEFAULT = {
    campaignToken: localStorage.getItem(`${PREFIX}campaignToken`),
    currencyCode: 'EUR',
    hasAuthenticated: localStorage.getItem(`${PREFIX}hasAuthenticated`) === 'true',
    languageCode: 'EN',
    tab: localStorage.getItem(`${PREFIX}tab`) ?? uuid(),
    token: localStorage.getItem(`${PREFIX}token`),
};
export const STATE = writable(DEFAULT);
export const TOKEN = derived(STATE, $STATE => $STATE.token ?? undefined);
export const CAMPAIGN_TOKEN = derived(STATE, $STATE => $STATE.campaignToken ?? undefined);
export const IS_AUTHENTICATED = derived(STATE, $STATE => $STATE.token !== null);
STATE.subscribe(state => {
    localStorage.setItem(`${PREFIX}hasAuthenticated`, String(state.hasAuthenticated));
    localStorage.setItem(`${PREFIX}languageCode`, state.languageCode);
    localStorage.setItem(`${PREFIX}currencyCode`, state.currencyCode);
    localStorage.setItem(`${PREFIX}tab`, state.tab);
    if (state.token === null) {
        localStorage.removeItem(`${PREFIX}token`);
    }
    else {
        localStorage.setItem(`${PREFIX}token`, state.token);
    }
    if (state.campaignToken === null) {
        localStorage.removeItem(`${PREFIX}campaignToken`);
    }
    else {
        localStorage.setItem(`${PREFIX}campaignToken`, state.campaignToken);
    }
});
